// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login__image[data-v-08168d92]{height:300px}.login__form[data-v-08168d92]{max-width:20rem;width:100%}.login-form__error[data-v-08168d92]{padding:.5rem 0}svg[data-v-08168d92]{fill:currentColor}.client-logo[data-v-08168d92]{width:120px;height:40px;object-fit:contain}", ""]);
// Exports
module.exports = exports;
